module.exports = __webpack_public_path__ + "static/media/m6.ddb0d9c4.png";